export default "__VITE_ASSET__BA4ccJR3__"